import React, { useState } from 'react';
import './PageCommon.css';
import './CableStock.css';

const cableStock = [
  { id: 'CS-001', name: 'Silicone Hook-Up Wire 22 AWG', color: 'Red', gauge: '22 AWG', material: 'Silicone', length: 500, unit: 'm', stock: 342, minStock: 100, location: 'A-12' },
  { id: 'CS-002', name: 'Shielded Servo Cable 26 AWG', color: 'Black', gauge: '26 AWG', material: 'PVC', length: 250, unit: 'm', stock: 89, minStock: 100, location: 'B-03' },
  { id: 'CS-003', name: 'High-Flex Robot Cable 20 AWG', color: 'Orange', gauge: '20 AWG', material: 'PUR', length: 100, unit: 'm', stock: 212, minStock: 50, location: 'A-07' },
  { id: 'CS-004', name: 'CAN Bus Twisted Pair', color: 'Blue/White', gauge: '24 AWG', material: 'PE', length: 300, unit: 'm', stock: 28, minStock: 100, location: 'C-01' },
  { id: 'CS-005', name: 'Power Cable 14 AWG', color: 'Yellow', gauge: '14 AWG', material: 'XLPE', length: 200, unit: 'm', stock: 415, minStock: 80, location: 'A-01' },
  { id: 'CS-006', name: 'Fiber Optic Duplex', color: 'Yellow', gauge: 'OM3', material: 'Glass', length: 50, unit: 'm', stock: 63, minStock: 20, location: 'D-05' },
];

const colorMap = { Red: '#ff3333', Black: '#888', Orange: '#ff6b00', 'Blue/White': '#0088ff', Yellow: '#ffcc00', Blue: '#0088ff' };

const CableStock = () => {
  const [view, setView] = useState('grid');

  const getStatus = (item) => {
    const ratio = item.stock / item.minStock;
    if (ratio < 0.3) return 'critical';
    if (ratio < 1) return 'low';
    return 'ok';
  };

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <div className="page-breadcrumb"><span>HOME</span><span className="sep">/</span><span className="current">CABLE STOCK</span></div>
        <h1 className="page-title"><span className="page-icon">≋</span>Cable Stock</h1>
        <p className="page-subtitle">Warehouse inventory for cable reels & raw materials</p>
      </div>

      <div className="page-content">
        <div className="kpi-row">
          <div className="kpi-card"><span className="kpi-value">{cableStock.reduce((s,c)=>s+c.stock,0)}</span><span className="kpi-label">TOTAL METERS</span></div>
          <div className="kpi-card"><span className="kpi-value">{cableStock.length}</span><span className="kpi-label">CABLE TYPES</span></div>
          <div className="kpi-card alert"><span className="kpi-value">{cableStock.filter(c=>getStatus(c)==='critical').length}</span><span className="kpi-label">CRITICAL</span></div>
          <div className="kpi-card warn"><span className="kpi-value">{cableStock.filter(c=>getStatus(c)==='low').length}</span><span className="kpi-label">LOW STOCK</span></div>
        </div>

        <div className="toolbar">
          <div className="filter-group">
            <span className="filter-label">VIEW:</span>
            <button className={`filter-btn ${view==='grid'?'active':''}`} onClick={()=>setView('grid')}>GRID</button>
            <button className={`filter-btn ${view==='list'?'active':''}`} onClick={()=>setView('list')}>LIST</button>
          </div>
        </div>

        <div className={`cable-stock-container ${view}`}>
          {cableStock.map(item => {
            const st = getStatus(item);
            const pct = Math.min(100, (item.stock / item.minStock) * 40);
            const cColor = colorMap[item.color] || '#00f0ff';
            return (
              <div key={item.id} className={`cable-stock-card ${st}`}>
                <div className="cs-color-stripe" style={{ background: cColor, boxShadow: `0 0 12px ${cColor}66` }} />
                <div className="cs-body">
                  <div className="cs-top">
                    <span className="cs-id mono">{item.id}</span>
                    <span className="cs-location mono">📍 {item.location}</span>
                  </div>
                  <div className="cs-name">{item.name}</div>
                  <div className="cs-tags">
                    <span className="meta-tag">{item.gauge}</span>
                    <span className="meta-tag">{item.material}</span>
                    <span className="meta-tag" style={{ color: cColor }}>{item.color}</span>
                  </div>
                  <div className="cs-stock-info">
                    <div className="cs-reel">
                      <svg width="40" height="40" viewBox="0 0 40 40">
                        <circle cx="20" cy="20" r="18" fill="none" stroke="var(--border-color)" strokeWidth="3"/>
                        <circle cx="20" cy="20" r="18" fill="none" stroke={cColor} strokeWidth="3"
                          strokeDasharray={`${pct * 1.13} 113`} strokeDashoffset="28"
                          style={{ opacity: 0.8, filter: `drop-shadow(0 0 4px ${cColor})` }}/>
                        <circle cx="20" cy="20" r="5" fill="none" stroke="var(--border-color)" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div className="cs-numbers">
                      <span className="cs-stock-num">{item.stock}<small>m</small></span>
                      <span className="cs-min">min {item.minStock}m</span>
                    </div>
                    <span className={`badge status-${st}`}>{st === 'ok' ? 'OK' : st.toUpperCase()}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CableStock;
